import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";

export const gradientTextStyle = style({
  backgroundImage: `linear-gradient(105deg, ${theme.colors.gradientA} -10%, ${theme.colors.gradientB} 25%, ${theme.colors.gradientC} 55%, ${theme.colors.gradientD} 90%)`,
  backgroundClip: "text",
  color: "transparent",
  display: "inline",
  WebkitBoxDecorationBreak: "clone",
  boxDecorationBreak: "clone",
});
